function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Used by lifecycle components.
// Runs a lifecycle action, which can be defined as either:
// - (String) The name of a function prop to call
// - (Function) A function to call
// When called, function will be passed the props (and additional arguments if passed).
export default function callWithProps(funcOrString, props) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  switch (_typeof(funcOrString)) {
    case 'string':
      {
        var func = props[funcOrString];
        if (typeof func !== 'function') throw new Error("\n          You specified a string argument of '".concat(funcOrString, "'\n          that should've corresponded to a function prop,\n          but there was no function prop with that key.\n        "));
        return func.apply(void 0, [props].concat(args));
      }

    case 'function':
      {
        return funcOrString.apply(void 0, [props].concat(args));
      }

    default:
      {
        throw new Error("\n          The argument provided must be a string or\n          function, you provided ".concat(funcOrString, "\n        "));
      }
  }
}